import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["provider"];
import React from 'react';
import PropTypes from 'prop-types';
import getProvider from './providers';
import { withTitle } from '../../HOC';
const VideoRender = _ref => {
  let {
      provider
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Provider = getProvider(provider);
  return /*#__PURE__*/React.createElement(Provider, props);
};
VideoRender.propTypes = {
  provider: PropTypes.string.isRequired
};
export default withTitle(VideoRender);
//# sourceMappingURL=VideoRender.js.map